export const formatPhoneNumber = (phoneNumber) => {
  const cleaned = phoneNumber.replace(/\D/g, "");
  const match = cleaned.match(/^(\d{0,2})(\d{0,2})(\d{0,5})(\d{0,4})$/);

  if (match) {
    const intlCode = match[1] ? `+${match[1]} ` : "";
    const ddd = match[2] ? `(${match[2]}) ` : "";
    const firstPart = match[3] ? `${match[3]}-` : "";
    const secondPart = match[4] ? match[4] : "";
    return `${intlCode}${ddd}${firstPart}${secondPart}`.trim();
  }

  return phoneNumber;
};

export const pluralize = (count, singular, plural) => {
  return `${count} ${count === 1 ? singular : plural}`;
};

export const addPorcentage = (value = 0, lang = "pt-BR") => {
  if (!value) return "0%";

  return `${value.toLocaleString(lang, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`;};

export const formatNumberToCurrency = (
  value = 0,
  lang = "pt-BR",
  currency = "BRL"
) => {
  if (!value) return "R$ 0,00";

  return value.toLocaleString(lang, { style: "currency", currency });
};

export const formatDate = (date, format, lang = "pt-BR") => {
  return new Intl.DateTimeFormat(lang, format).format(date);
};

/**
 * dd-MM-yyyy para querystring (ParseExact no backend). Usa componentes do calendario local.
 */
export const formatDateForApiQuery = (date) => {
  if (!date || !(date instanceof Date) || Number.isNaN(date.getTime())) {
    return "";
  }
  const d = String(date.getDate()).padStart(2, "0");
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const y = date.getFullYear();
  return `${d}-${m}-${y}`;
};
